import React, { VFC } from 'react';

import { cn } from '../../../lib/css/className/className';
import './Control.css';
import { TestProps } from '../../../internal/types/testTypes';
import { SwitcherSize } from '../types';
import { getColorSkin } from '../../../lib/skin/getColorSkin/getColorSkin';

export interface ControlProps extends TestProps {
    size: SwitcherSize;
    isChecked?: boolean;
    isDisabled?: boolean;
    isHovered?: boolean;
    isFocused?: boolean;
}

const cnControl = cn('SwitcherControl');

export const Control: VFC<ControlProps> = function Control(props) {
    const { isChecked, isHovered, isFocused, isDisabled, size } = props;
    const skinClass = getColorSkin(isChecked ? 'accent' : 'gray-low-contrast', { isDisabled, isHovered });

    return (
        <div
            className={cnControl(
                {
                    checked: isChecked,
                    hovered: isHovered,
                    focused: isFocused,
                    disabled: isDisabled,
                    size,
                },
                [skinClass],
            )}
            data-testid={props['data-testid']}
        />
    );
};
